var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 17.8125C15.3471 17.8125 16.0677 17.5122 16.6656 16.9117C17.2635 16.3111 17.5625 15.5893 17.5625 14.7461C17.5625 13.9029 17.2622 13.1823 16.6617 12.5844C16.0611 11.9865 15.3393 11.6875 14.4961 11.6875C13.6529 11.6875 12.9323 11.9878 12.3344 12.5883C11.7365 13.1889 11.4375 13.9107 11.4375 14.7539C11.4375 15.5971 11.7378 16.3177 12.3383 16.9156C12.9389 17.5135 13.6607 17.8125 14.5039 17.8125ZM14.5 32.2937C18.3792 28.7646 21.2448 25.5635 23.0969 22.6906C24.949 19.8177 25.875 17.2875 25.875 15.1C25.875 11.6645 24.777 8.85133 22.5811 6.66062C20.3851 4.47021 17.6914 3.375 14.5 3.375C11.3086 3.375 8.6149 4.47021 6.41894 6.66062C4.22298 8.85133 3.125 11.6645 3.125 15.1C3.125 17.2875 4.07292 19.8177 5.96875 22.6906C7.86458 25.5635 10.7083 28.7646 14.5 32.2937ZM14.5 35.75C9.80417 31.7542 6.29688 28.0427 3.97813 24.6156C1.65938 21.1885 0.5 18.0167 0.5 15.1C0.5 10.725 1.90729 7.23958 4.72188 4.64375C7.53646 2.04792 10.7958 0.75 14.5 0.75C18.2042 0.75 21.4635 2.04792 24.2781 4.64375C27.0927 7.23958 28.5 10.725 28.5 15.1C28.5 18.0167 27.3406 21.1885 25.0219 24.6156C22.7031 28.0427 19.1958 31.7542 14.5 35.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.ef6e48edfa06e644667182c7458a49df.svg";
export { ForwardRef as ReactComponent };